import * as SelectPrimitive from "@radix-ui/react-select";
import React from "react";

import { cn } from "@/utils/cn/cn";

import { CustomCheckbox } from "../Checkbox";

interface SelectItemCheckboxProps
  extends React.ComponentPropsWithoutRef<typeof SelectPrimitive.Item> {
  checked?: boolean;
}

const SelectItemCheckbox = React.forwardRef<
  React.ElementRef<typeof SelectPrimitive.Item>,
  SelectItemCheckboxProps
>(({ className, children, checked, value, ...props }, ref) => (
  <SelectPrimitive.Item
    ref={ref}
    value={value}
    className={cn(
      "relative flex gap-2 w-full cursor-pointer select-none items-center rounded-sm py-3 px-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      className
    )}
    {...props}
  >
    <CustomCheckbox
      checked={checked}
      className="rounded-[4px] w-[22px] h-[22px]"
      id={value?.toString()}
    />
    <SelectPrimitive.ItemText className="text-sm">
      {children}
    </SelectPrimitive.ItemText>
  </SelectPrimitive.Item>
));

SelectItemCheckbox.displayName = "SelectItemCheckbox";
export { SelectItemCheckbox };
